import styled, { css } from 'styled-components';
import { pseudo } from 'styles/utils';

export const LabelStyled = styled.label`
  cursor: pointer;
  display: ${props => (props.labelsAlignment ? 'flex' : 'inline-flex')};
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${props =>
    (props.labelsAlignment &&
      (props.labelsAlignment === 'justify'
        ? 'space-between'
        : `flex-${props.labelsAlignment}`)) ||
    'flex-start'};
  width: 100%;
  padding-left: ${props => props.theme.spacing.xsmall};
  color: ${props => props.theme.color.wfBlack};
  font-size: inherit;
  font-weight: ${props =>
    props.theme.font.weight[props.checked ? 'xbold' : 'regular']};
  user-select: none;
`;

export const LabelSecondaryStyled = styled.small`
  margin-left: ${props => props.theme.spacing.xsmall};
  font-size: inherit;
  font-weight: ${props => props.theme.font.weight.regular};
  color: ${props => props.theme.color.wfGrey};
  cursor: inherit;
`;

export const disabledWrapper = css`
  cursor: not-allowed;
  opacity: 0.2;
`;

export const focus = css`
  box-shadow: 0 0 4px ${props => props.theme.color.wfGrey300};
`;

// Delete it after refactor =>

export const fieldRadioCheckStyles = css`
  font-size: ${props => props.theme.font.size[props.size]};
  line-height: 1em;
  padding: 0.5rem 0 0.25rem 0.5rem;
`;

export const labelStyles = css`
  cursor: pointer;
  position: relative;
  padding-left: 1.5em;
  user-select: none;
  color: ${props => props.theme.color.wfBlack};
  font-size: ${props => props.theme.font.size.default};
  display: ${props => (props.labelsAlignment ? 'flex' : 'inline-flex')};
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${props =>
    props.labelsAlignment
      ? props.labelsAlignment === 'justify'
        ? 'space-between'
        : `flex-${props.labelsAlignment}`
      : null};
`;

export const pseudoRadioCheck = css`
  ${pseudo('absolute', '1em', '1em')};
  margin-right: 0.5em;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;

export const inputRadioCheck = css`
  cursor: pointer;
  opacity: 0;
  position: absolute;
`;
